import { useMutation } from 'react-query';

import { useCurrentUser } from '@lib/hooks';
import axiosClient from '@lib/utils/axiosClient';

import { Message } from '../types';

type Data = Partial<Message>;
type Response = Message;

export default function useMessageCreateOne() {
  const currentUser = useCurrentUser();

  const mutationFn = async (data: Data) => {
    if (!currentUser) return;

    const response = await axiosClient.post('/messages', {
      channel: 'chat',
      patient: currentUser.id,
      recipient: currentUser.user,
      recipientType: 'staff',
      ref: 'chat',
      secure: true,
      status: 'delivered',
      type: 'inbound',
      user: currentUser.user,
      ...data,
    });
    return response.data as Response;
  };

  const mutation = useMutation(mutationFn);

  return mutation;
}
